import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import * as appActions from 'lib/store/app'
import * as userActions from 'lib/store/user'
import Settings from 'components/settings/Settings'

export class SettingsContainer extends React.PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    fetchUserProfile: PropTypes.func.isRequired,
    requestDeleteAccount: PropTypes.func.isRequired,
    updateSettings: PropTypes.func.isRequired,
    showMe: PropTypes.string,
    distanceIn: PropTypes.string,
    ageRange: PropTypes.arrayOf(PropTypes.number),
    maxDistance: PropTypes.number
  }

  componentDidMount() {
    document.title = 'Settings'

    this.props.fetchUserProfile().then(profile => {
      this.props.setLoading(false)
    })
  }

  transformToApiPayload = settings => {
    return {
      settingsSearchFor: settings.showMe,
      settingsAgeRangeFrom: settings.ageRange[0],
      settingsAgeRangeTo: settings.ageRange[1],
      settingsDistanceMax: settings.maxDistance,
      settingsShowDistanceIn: settings.distanceIn
    }
  }

  handleChanged = updatedSettings => {
    // The update action is debounced, meaning it should only be triggered
    // after a specified delay, and if no update action was triggered in
    // the meantime.
    const DELAY_UNTIL_ACTION_FIRED = 400
    clearTimeout(this.debounceAction)

    this.debounceAction = setTimeout(() => {
      const apiPayload = this.transformToApiPayload(updatedSettings)
      this.props.updateSettings(apiPayload)
    }, DELAY_UNTIL_ACTION_FIRED)
  }

  handleDelete = () => {
    this.props.requestDeleteAccount()
  }

  render() {
    const { isLoading, showMe, distanceIn, ageRange, maxDistance } = this.props
    if (isLoading) return null

    return (
      <Settings
        initialValues={{
          showMe,
          distanceIn,
          ageRange,
          maxDistance
        }}
        onChanged={this.handleChanged}
        onDelete={this.handleDelete}
      />
    )
  }
}

const mapStateToProps = state => ({
  showMe: state.user.profile.settingsSearchFor,
  distanceIn: state.user.profile.settingsShowDistanceIn,
  ageRange: [
    state.user.profile.settingsAgeRangeFrom,
    state.user.profile.settingsAgeRangeTo
  ],
  maxDistance: state.user.profile.settingsDistanceMax,
  isLoading: state.app.isLoading
})

const mapDispatchToProps = dispatch => ({
  fetchUserProfile: () => dispatch(userActions.fetchUserProfile()),
  requestDeleteAccount: () => dispatch(userActions.requestDeleteAccount()),
  updateSettings: settings => dispatch(userActions.updateSettings(settings)),
  setLoading: loadingState => dispatch(appActions.setLoading(loadingState))
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer)



// WEBPACK FOOTER //
// ./src/components/settings/SettingsContainer.js